"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZGetTokenTransactionResponse = exports.ZPurchaseTokensResponse = exports.ZTokenRedemptionOrder = exports.ZTokenRedemptionInsert = exports.ZTokenRedemptionSelect = exports.ZTokenRedemptionOptionsItem = exports.ZTokenRedemptionOptionSelectResponse = exports.ZTokenRedemptionOptionPrize = exports.ZTokenRedemptionOptionSelect = exports.TokenRedemptionOptionTypeEnum = exports.TokenCostInGBP = void 0;
const dbEnums_1 = require("@daymade/common-lib/dbEnums");
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const types_1 = require("@daymade/common-lib/types");
const zod_1 = require("zod");
const draw_1 = require("../draw/draw");
const drawOrder_1 = require("../draw/drawOrder");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
const order_1 = require("../order");
const models_1 = require("../payment/models");
const prize_1 = require("../prize");
const models_2 = require("../tree/models");
const models_3 = require("../winner/models");
exports.TokenCostInGBP = 50;
exports.TokenRedemptionOptionTypeEnum = dbEnums_1.TokenRedemptionOptionType;
exports.ZTokenRedemptionOptionSelect = zodSchemas_generated_1.zodSelectTokenRedemptionOption.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectTokenRedemptionOption.shape, {
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
}));
exports.ZTokenRedemptionOptionPrize = prize_1.ZPrizeSelect.pick({
    id: true,
    slug: true,
    type: true,
    title: true,
    subheading: true,
    overviewBody: true,
    whatsIncludedBody: true,
    imageLocations: true,
    requiresDeliveryAddress: true,
    requiresEmailAddress: true,
    requiresPhoneNumber: true,
    additionalQuestionsForPlayer: true,
}).extend({
    products: prize_1.ZProductSelect.pick({
        id: true,
        name: true,
        description: true,
        imageLocation: true,
    }).array(),
});
exports.ZTokenRedemptionOptionSelectResponse = exports.ZTokenRedemptionOptionSelect.pick({
    id: true,
    code: true,
    slug: true,
    type: true,
    price: true,
    title: true,
    description: true,
    heroImage: true,
    group: true,
    groupOrder: true,
}).extend({
    drawDetails: zod_1.z
        .object({
        gameType: zod_1.z.string().nullable(),
        group: zod_1.z.string().nullable(),
        drawTypeCode: zod_1.z.string(),
        numberSetup: dbJsonModels_1.ZDrawTypeNumberSetup.nullable(),
        schedule: zod_1.z.string().nullable(),
        nextDrawId: zod_1.z.number().nullable(),
        nextDrawDate: zod_1.z.coerce.date().nullable(),
        numEntries: zod_1.z.number().nullable(),
        entryCap: zod_1.z.number().nullable(),
        maxPlayerEntries: zod_1.z.number().nullable(),
        prize: prize_1.ZPrizeSelect.pick({
            id: true,
            slug: true,
            title: true,
            subheading: true,
            overviewBody: true,
            whatsIncludedBody: true,
            imageLocations: true,
        }).nullable(),
    })
        .optional(),
    prizes: exports.ZTokenRedemptionOptionPrize.array().optional(),
});
exports.ZTokenRedemptionOptionsItem = exports.ZTokenRedemptionOptionSelect.pick({
    id: true,
    code: true,
    slug: true,
    type: true,
    price: true,
    title: true,
    description: true,
    heroImage: true,
    group: true,
    groupOrder: true,
    status: true,
}).extend({
    drawDetails: zod_1.z
        .object({
        gameType: zod_1.z.string().nullable(),
        group: zod_1.z.string().nullable(),
        drawTypeCode: zod_1.z.string().nullable(),
        numberSetup: dbJsonModels_1.ZDrawTypeNumberSetup.nullable(),
        schedule: zod_1.z.string().nullable(),
        nextDrawDate: zod_1.z.coerce.date().nullable(),
        numEntries: zod_1.z.number().nullable(),
        entryCap: zod_1.z.number().nullable(),
        maxPlayerEntries: zod_1.z.number().nullable(),
        prizeTitle: zod_1.z.string().nullable(),
        prizeSubheading: zod_1.z.string().nullable(),
        prizeImageLocation: zod_1.z.string().nullable(),
    })
        .optional(),
    prizes: exports.ZTokenRedemptionOptionPrize.array().optional(),
});
exports.ZTokenRedemptionSelect = zodSchemas_generated_1.zodSelectTokenRedemption.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectTokenRedemption.shape, {
    orderId: zod_1.z.optional(zod_1.z.string().nullable()),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
}));
exports.ZTokenRedemptionInsert = zodSchemas_generated_1.zodInsertTokenRedemption;
exports.ZTokenRedemptionOrder = zod_1.z.object({
    tokenRedemption: exports.ZTokenRedemptionSelect.pick({
        id: true,
        status: true,
        playerId: true,
        tokenRedemptionOptionId: true,
    }),
    order: order_1.ZOrderSelect,
    drawOrder: zod_1.z.optional(drawOrder_1.ZDrawOrderSelect.nullable()),
    draw: zod_1.z.optional(draw_1.ZDrawSelect.nullable()),
    drawSchedule: zod_1.z.optional(draw_1.ZDrawScheduleSelect.nullable()),
    prize: zod_1.z.optional(prize_1.ZPrizeSelect.nullable()),
    prizeOrder: zod_1.z.optional(models_3.ZPrizeOrderSelect.nullable()),
    treeLog: zod_1.z.optional(models_2.ZTreeLogSelect.nullable()),
});
exports.ZPurchaseTokensResponse = zod_1.z.object({
    tokenOrder: zodSchemas_generated_1.zodSelectTokenOrder
        .pick({
        id: true,
        createdAt: true,
        status: true,
        tokenAmount: true,
        playerId: true,
        orderId: true,
    })
        .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectTokenOrder.shape, {
        createdAt: zod_1.z.coerce.date(),
    })),
    order: zodSchemas_generated_1.zodSelectOrder
        .pick({
        id: true,
        createdAt: true,
        status: true,
        playerId: true,
        isSubscription: true,
        totalFiatAmount: true,
        tokenAmount: true,
        paymentMethod: true,
        subscriptionId: true,
    })
        .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectOrder.shape, { createdAt: zod_1.z.coerce.date() })),
    adyenPaymentSession: zod_1.z.optional(zod_1.z.object({
        id: zod_1.z.string(),
        sessionData: zod_1.z.string(),
        adyenPaymentSessionId: zod_1.z.string(),
    })),
});
exports.ZGetTokenTransactionResponse = models_1.ZAccountJournalSelectPrivate.pick({
    id: true,
    refType: true,
    refId: true,
})
    .extend({
    createdAt: zod_1.z.coerce.date(),
    amount: zod_1.z.number(),
    notes: zod_1.z.string(),
})
    .array();
//# sourceMappingURL=models.js.map